module.exports = __webpack_public_path__ + "img/course_bg_02.9f07e4bd.png";